import { styled, Box, Button, Switch } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '64px',
});

const TopHeadingGrid = styled(Box)({
  margin: '20px 20px 7px 20px',
  display: 'flex',
  justifyContent: 'space-between',
});

const TOSButton = styled(Button)({
  ...Buttons.baseStyle.primaryButton,
});

const GapSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: ColorsV2.acent,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: ColorsV2.acent,
  },
  '& .MuiSwitch-switchBase': {
    color: 'grey', // This color could be added to main color scheme as 'inactive', or 'disabled'-primary
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'lightgrey', // This color could be added to main color scheme as 'inactive', or 'disabled'-secondary
  },
});

export { Container, TopHeadingGrid, TOSButton, GapSwitch };
